import React from 'react'
import { SortableHandle } from 'react-sortable-hoc'
import { ImageSetItemOverlay } from '../../../../core/components/styled'

const ImageSetItemDragHandle = () => <ImageSetItemOverlay />

export default SortableHandle(ImageSetItemDragHandle)
